<app-loader></app-loader>
<app-sidenavbartop id="nav_bar_top" class="none" *ngIf="(logado | async) && !navBarLateral" [sessao]="sessao"></app-sidenavbartop>
<div class="wrapper">
  <!-- Sidebar  -->
  <app-sidenavbar id="sidebar" class="p-0" *ngIf="(logado | async) && navBarLateral && !loginSiga"></app-sidenavbar>
  <!-- Page Content  -->
  <div id="content" class="w-100 p-0">
    <div class="row px-3">
      <nav class="navbar navbar-expand-lg navbar-light bg-light mb-0 py-1" id="nav-b"
        [style.display]="((logado|async) && !loginSiga) ? 'block' : 'none'">
        <div class="container-fluid px-1 w-100">
          <button type="button" id="sidebarCollapse" (click)="toggleSideBar()" class="btn btn-menu">
            <i class="fa fa-bars fa-lg" aria-hidden="true"></i>
          </button>
          <div class="div-info-login-rigth" *ngIf="!navBarLateral">
            <li class="nav-item nav-link info">Login: <b>{{sessao.login}}</b></li>
          </div>
          <div class="navbar-collapse collapse float-right col-12 d-flex" id="navbarSupportedContent">
            <div class="d-flex" style="width: 100%;">
              <div class="d-flex justify-content-end" style="width: calc(100% - 150px);">
                <ul class="nav navbar-nav">
                  <li class="nav-item nav-link info" *ngIf="allowChangeEmpresa()">
                    <button class="btn py-0 m-r-2" *ngIf="visibleDefaultEmpresa()" (click)="defaultEmpresa()"
                      title="Ir para {{sessao.razaoSocial}}" data-toggle="tooltip" data-placement="top">
                      <i class="fa fa-star fa-lg"></i>
                    </button>
                    Empresa: <b>{{currentEmpresaPerfil.razaoSocial}}</b>
                    <button class="btn py-0 float-right" (click)="openSelectEmpresa()"
                      title="Selecionar Empresa" data-toggle="tooltip" data-placement="top">
                      <i class="fa fa-edit fa-lg"></i>
                    </button>
                  </li>
                  <li class="nav-item nav-link info" *ngIf="!allowChangeEmpresa() && navBarLateral">Empresa: <b>{{sessao.razaoSocial}}</b>
                  </li>
                  <li class="nav-item nav-link info" *ngIf="navBarLateral">Login: <b>{{sessao.login}}</b></li>                  
                </ul>
              </div>
              <div style="width: 80px;text-align:center">
                <button class="btn" *ngIf="navBarLateral"><a class="nav-link p-0" (click)="logoff()" href="javascript:void(0)"><i
                      class="fa fa-sign-out"
                      aria-hidden="true"></i> Sair</a></button>
              </div>
            </div>
          </div>

        </div>
      </nav>
      <div class="col-12" style="margin-bottom: 100px;">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-notificacao [habilitado]="habilitarNotificacao()"></app-notificacao>
<app-chat [navBarStatus]="sideBar" *ngIf="false"></app-chat>